module.exports = __webpack_public_path__ + "img/loading-1.c84358fb.gif";